import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface YoutubeVideoYoutubeUrlModel extends BaseModel {
  variables?: { [key: string]: string } | YoutubeVideoYoutubeUrlVariables;
}

export interface YoutubeVideoYoutubeUrlVariables {
  YoutubeVideoUrl: string;
}

export class YoutubeVideoYoutubeUrlInitVariables implements YoutubeVideoYoutubeUrlVariables {
  YoutubeVideoUrl = '';
}

export class YoutubeVideoYoutubeUrlInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new YoutubeVideoYoutubeUrlInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
